import { render, staticRenderFns } from "./VersionEditionSelection.vue?vue&type=template&id=2901f5ff&scoped=true"
import script from "./VersionEditionSelection.vue?vue&type=script&lang=js"
export * from "./VersionEditionSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2901f5ff",
  null
  
)

export default component.exports